/**
 * @generated SignedSource<<21a12a44bbf389d121930692154963f8>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "runningScheduleModel"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "scheduleId"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "scheduleId"
        }
    ], v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    }, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
    }, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    }, v6 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        },
        {
            "kind": "Variable",
            "name": "model",
            "variableName": "runningScheduleModel"
        }
    ], v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    }, v8 = {
        "alias": null,
        "args": null,
        "concreteType": "Avatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": [
                    {
                        "kind": "Literal",
                        "name": "queryTransform",
                        "value": "width=300&height=300&mode=crop&scale=both"
                    }
                ],
                "kind": "ScalarField",
                "name": "url",
                "storageKey": "url(queryTransform:\"width=300&height=300&mode=crop&scale=both\")"
            },
            (v3 /*: any*/)
        ],
        "storageKey": null
    }, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "color",
        "storageKey": null
    }, v10 = [
        (v9 /*: any*/)
    ], v11 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "firstname",
        "storageKey": null
    }, v12 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastname",
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "ScheduleDetailsPageQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v2 /*: any*/),
                    "concreteType": "Schedule",
                    "kind": "LinkedField",
                    "name": "schedule",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "ScheduleAssignmentTypesPanel_schedule"
                        },
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "ScheduleGeneralInfoPanel_schedule"
                        },
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "runningScheduleModel",
                                    "variableName": "runningScheduleModel"
                                }
                            ],
                            "kind": "FragmentSpread",
                            "name": "ScheduleShiftTablePanel_schedule"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v1 /*: any*/),
                (v0 /*: any*/)
            ],
            "kind": "Operation",
            "name": "ScheduleDetailsPageQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v2 /*: any*/),
                    "concreteType": "Schedule",
                    "kind": "LinkedField",
                    "name": "schedule",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ScheduleAssignmentTypeConnection",
                            "kind": "LinkedField",
                            "name": "assignmentTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ScheduleAssignmentType",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        (v3 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "AssignmentType",
                                            "kind": "LinkedField",
                                            "name": "assignmentType",
                                            "plural": false,
                                            "selections": [
                                                (v3 /*: any*/),
                                                (v4 /*: any*/)
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        (v3 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "archived",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "inactivatedFrom",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "currentUserPermissions",
                            "storageKey": null
                        },
                        (v5 /*: any*/),
                        {
                            "alias": null,
                            "args": (v6 /*: any*/),
                            "concreteType": "ScheduleShiftConnection",
                            "kind": "LinkedField",
                            "name": "runningSchedule",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ScheduleShiftEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ScheduleShift",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": null,
                                                    "kind": "LinkedField",
                                                    "name": "assignedEntity",
                                                    "plural": false,
                                                    "selections": [
                                                        (v7 /*: any*/),
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "Asset",
                                                                    "kind": "LinkedField",
                                                                    "name": "asset",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v5 /*: any*/),
                                                                        (v3 /*: any*/),
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                (v8 /*: any*/),
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": (v10 /*: any*/),
                                                                                    "type": "Asset",
                                                                                    "abstractKey": null
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        (v9 /*: any*/),
                                                                                        (v11 /*: any*/),
                                                                                        (v12 /*: any*/)
                                                                                    ],
                                                                                    "type": "User",
                                                                                    "abstractKey": null
                                                                                }
                                                                            ],
                                                                            "type": "IHaveAvatar",
                                                                            "abstractKey": "__isIHaveAvatar"
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "type": "SchedulableAsset",
                                                            "abstractKey": null
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "User",
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v11 /*: any*/),
                                                                        (v12 /*: any*/),
                                                                        (v3 /*: any*/),
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                (v8 /*: any*/),
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        (v9 /*: any*/),
                                                                                        (v5 /*: any*/)
                                                                                    ],
                                                                                    "type": "Asset",
                                                                                    "abstractKey": null
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        (v5 /*: any*/)
                                                                                    ],
                                                                                    "type": "Company",
                                                                                    "abstractKey": null
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": (v10 /*: any*/),
                                                                                    "type": "User",
                                                                                    "abstractKey": null
                                                                                }
                                                                            ],
                                                                            "type": "IHaveAvatar",
                                                                            "abstractKey": "__isIHaveAvatar"
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "type": "SchedulableUser",
                                                            "abstractKey": null
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                (v3 /*: any*/)
                                                            ],
                                                            "type": "Node",
                                                            "abstractKey": "__isNode"
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "AssignmentType",
                                                    "kind": "LinkedField",
                                                    "name": "assignmentType",
                                                    "plural": false,
                                                    "selections": [
                                                        (v4 /*: any*/),
                                                        (v3 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ScheduleShiftChangeRequestConnection",
                                                    "kind": "LinkedField",
                                                    "name": "changeRequests",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "totalCount",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "end",
                                                    "storageKey": null
                                                },
                                                (v3 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "start",
                                                    "storageKey": null
                                                },
                                                (v7 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "cursor",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "endCursor",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "hasNextPage",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": (v6 /*: any*/),
                            "filters": [
                                "model"
                            ],
                            "handle": "connection",
                            "key": "ScheduleShiftTable_schedule_runningSchedule",
                            "kind": "LinkedHandle",
                            "name": "runningSchedule"
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "210dbeab7df36b8464b9b754ef708de3",
            "id": null,
            "metadata": {},
            "name": "ScheduleDetailsPageQuery",
            "operationKind": "query",
            "text": "query ScheduleDetailsPageQuery(\n  $scheduleId: ID!\n  $runningScheduleModel: GetRunningScheduleRequestInput!\n) {\n  schedule(id: $scheduleId) {\n    ...ScheduleAssignmentTypesPanel_schedule\n    ...ScheduleGeneralInfoPanel_schedule\n    ...ScheduleShiftTablePanel_schedule_1gb8Rr\n    id\n  }\n}\n\nfragment AssignmentTypeChip_assignmentType on AssignmentType {\n  id\n  title\n}\n\nfragment Avatar_iHaveAvatar on IHaveAvatar {\n  __isIHaveAvatar: __typename\n  avatar {\n    url(queryTransform: \"width=300&height=300&mode=crop&scale=both\")\n    id\n  }\n  ... on Asset {\n    color\n    name\n  }\n  ... on Company {\n    name\n  }\n  ... on User {\n    color\n    firstname\n    lastname\n  }\n}\n\nfragment ScheduleAssignmentTypesPanel_schedule on Schedule {\n  assignmentTypes {\n    nodes {\n      id\n      assignmentType {\n        ...AssignmentTypeChip_assignmentType\n        id\n      }\n    }\n  }\n  id\n}\n\nfragment ScheduleGeneralInfoPanel_schedule on Schedule {\n  archived\n  inactivatedFrom\n  currentUserPermissions\n  id\n  name\n}\n\nfragment ScheduleShiftTablePanel_schedule_1gb8Rr on Schedule {\n  ...ScheduleShiftTable_schedule_1gb8Rr\n}\n\nfragment ScheduleShiftTable_schedule_1gb8Rr on Schedule {\n  currentUserPermissions\n  id\n  runningSchedule(first: 10, model: $runningScheduleModel) {\n    edges {\n      node {\n        assignedEntity {\n          __typename\n          ... on SchedulableAsset {\n            asset {\n              ...Avatar_iHaveAvatar\n              name\n              id\n            }\n          }\n          ... on SchedulableUser {\n            user {\n              ...Avatar_iHaveAvatar\n              firstname\n              lastname\n              id\n            }\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        assignmentType {\n          title\n          id\n        }\n        changeRequests {\n          totalCount\n        }\n        end\n        id\n        start\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "c16e1434ab7c63d421e8f05cc2663318";
export default node;
